/* Created by Interactive 63 - https://interactive63.com */
/**
 * Number formatting for generated CSS: fixed maximum decimals with trailing zeros trimmed.
 */

/** Formats a number with at most `decimals` places, trimming trailing zeros and negative zero. */
export function formatNumber(value: number, decimals: number): string {
  const rounded = Number(value.toFixed(decimals));
  return String(Object.is(rounded, -0) ? 0 : rounded);
}
